module.exports = __webpack_public_path__ + "static/media/royal_guard_boots.a3aa5ad3.png";